import { render } from "./ShareCard.vue?vue&type=template&id=59644cda"
import script from "./ShareCard.vue?vue&type=script&lang=js"
export * from "./ShareCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__